import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/inventario_materiales/getMaterialesUnidadByUnidad.php';

export default function getMaterialesUnidadByUnidad({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}